export default __webpack_public_path__ + "static/newsletter-tablet-dca3d98e3e8fd95ee46ef523010fbd86.jpg";